import { FormLabel, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import { errorText } from "@/utils";

interface IFormOtpField {
	label?: string;
	errorMessage?: string;
	containerClassName?: string;
	onChange: (otp: string) => void;
	isFormError?: boolean;
}

export default function FormOtpField({
	label,
	errorMessage,
	containerClassName,
	isFormError,
	onChange,
}: IFormOtpField) {
	const [otp, setOtp] = useState(["", "", "", ""]);
	const inputRefs = useRef<Array<HTMLInputElement | null>>([null, null, null, null]);
	const [isFormErrorHappened, setIsFormErrorHappened] = useState(false);

	useEffect(() => {
		if (isFormError) {
			setIsFormErrorHappened(true);
		}
	}, [isFormError]);

	const handleChange = (index: number, value: string) => {
		if (!/^[0-9]?$/.test(value)) {
			return;
		}

		const newOtp = [...otp];

		newOtp[index] = value;
		setOtp(newOtp);
		onChange(newOtp.join(""));
		setIsFormErrorHappened(false);

		if (value && index < 3) {
			inputRefs.current[index + 1]?.focus();
		}
	};

	const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
		if (e.key === "Backspace" && !otp[index] && index > 0) {
			inputRefs.current[index - 1]?.focus();
			if (isFormErrorHappened) {
				setIsFormErrorHappened(false);
			}
		}
	};

	return (
		<div className={`space-y-1 mb-2 ${containerClassName}`}>
			{label && (
				<FormLabel component="label" sx={{ color: "#11110F", fontSize: "14px", fontWeight: "500" }}>
					{label}
				</FormLabel>
			)}
			<div className="flex gap-2">
				{otp.map((digit, index) => (
					<TextField
						key={index}
						inputProps={{ maxLength: 1, style: { textAlign: "center", fontSize: "20px" } }}
						inputRef={(el) => (inputRefs.current[index] = el)}
						sx={{
							height: "44px",
							"& .MuiOutlinedInput-root": {
								borderRadius: "12px",
								"& fieldset": {
									border: isFormErrorHappened ? "2px solid rgb(233, 15, 15)" : "1px solid #E8E6E2",
								},
								"&:hover fieldset": { border: "0px solid #B8431A70" },
								"&.Mui-focused fieldset": { border: "0px solid #11110F" },
							},
						}}
						value={digit}
						variant="outlined"
						onChange={(e) => handleChange(index, e.target.value)}
						onKeyDown={(e) => handleKeyDown(index, e)}
					/>
				))}
			</div>
			{errorMessage && <p className="text-[12px] text-danger mt-1">{errorText(errorMessage)}</p>}
		</div>
	);
}
